<template>
<div>
    
    <el-row :gutter="5">
      <el-col :span="2">旧密码：</el-col>
      <el-col :span="4"><el-input v-model="CurPassword" type="password" placeholder="旧密码" auto-complete="new-password"></el-input> </el-col>
      <el-col :span="18">&nbsp;</el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :span="2">新密码：</el-col>
      <el-col :span="4"><el-input v-model="NewPassword" type="password" placeholder="新密码"></el-input> </el-col>
      <el-col :span="18">&nbsp;</el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :span="2">重新输入新密码：</el-col>
      <el-col :span="4"><el-input v-model="ReNewPassword" type="password" placeholder="重新输入新密码"></el-input> </el-col>
      <el-col :span="18">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="4"><el-button type="primary" :loading="Loading" @click="submitpassword">提交</el-button></el-col>
      <el-col :span="18">&nbsp;</el-col>
    </el-row>
</div>
</template>

<script>
    import ChangePasswordJs from "./ChangePassword.js";
    export default ChangePasswordJs;
</script>

<style scoped>
    .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword/ChangePassword.vue